<template>
  <div class="container-fluid container-with-vertical-nav full-height cards-pf">
    <div v-if="$apollo.loading">
      <div style="margin-top: 10%;" class="text-center">
        <div class="spinner" />
        <strong>กำลังโหลด..</strong>
      </div>
    </div>
    <div v-else>
      <div class="row toolbar-pf row-toolbar-on-cards-page">
        <div class="col-sm-12">
          <div class="toolbar-pf-actions toolbar-page-header">
            <div>
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link tag="a" :to="{ name: 'settings.groups.index' }">
                    จัดการหน่วยงาน
                  </router-link>
                </li>
                <li class="breadcrumb-item active">แสดงข้อมูลหน่วยงาน</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-cards-pf">
        <div class="col-xs-12">
          <div class="card-pf">
            <div class="card-pf-heading">
              <h2 class="card-pf-title">
                แสดงข้อมูลหน่วยงาน
                <router-link tag="a" class="btn btn-default pull-right" :to="{ name: 'settings.groups.edit' }">
                  แก้ไข
                </router-link>
              </h2>
            </div>
            <div class="card-pf-body">
              <dl class="dl-horizontal">
                <dt>ชื่อหน่วยงาน</dt>
                <dd>{{ group.name }}</dd>
                <dt>สังกัด</dt>
                <dd>{{ group.department }}</dd>
                <dt>ประเภท</dt>
                <dd>{{ group.type }}</dd>
                <dt>ประธาน</dt>
                <dd>{{ group.cheifName }}</dd>
                <dt>อาจารย์ที่ปรึกษา</dt>
                <dd>
                  {{ group.advisor ? group.advisor.firstName + ' ' + group.advisor.lastName : 'ไม่ได้กำหนด' }}
                  (<a href="#" data-toggle="modal" data-target="#setAdvisorUserDialog">กำหนดอาจารย์ที่ปรึกษา</a>)
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-cards-pf">
        <div class="col-xs-12">
          <div class="card-pf">
            <div class="card-pf-heading">
              <h2 class="card-pf-title">
                รายชื่อผู้ประสานงาน
              </h2>
            </div>
            <div class="card-pf-body">
              <table class="table table-striped table-bordered no-margin">
                <thead>
                  <tr>
                    <td class="text-center" width="40">#</td>
                    <td>ชือ นามสกุล</td>
                    <td class="text-center" width="100">ประเภท</td>
                    <td class="text-center table-view-pf-actions">ลบ</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, index) in group.users" :key="index">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td>{{ user.firstName + ' ' + user.lastName }}</td>
                    <td class="text-center">นักศืกษา</td>
                    <td class="text-center">
                      <a href="#" @click="removeUserFromGroup(user._id)">ลบ</a>
                    </td>
                  </tr>
                  <tr v-if="group && !group.users.length">
                    <td colspan="4" class="text-center text-muted"><em>ไม่มีข้อมูล</em></td>
                  </tr>
                  <tr>
                    <td colspan="4" class="text-center">
                      <button type="button" class="btn btn-default" data-toggle="modal" data-target="#addPreRequisiteCourseModal">เพิ่มรายชื่อผู้ประสานงาน</button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div id="addPreRequisiteCourseModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                        <span class="pficon pficon-close" />
                      </button>
                      <h4 class="modal-title">เพิ่มรายชื่อผู้ประสานงาน</h4>
                    </div>
                    <div class="modal-body">
                      <div class="alert alert-info">
                        <span class="pficon pficon-info" />
                        โปรดกรอกรหัสนักศึกษาและคลิกปุ่มค้นหา เพื่อตรวจสอบความถูกต้องก่อนเพิ่มลงในตาราง
                      </div>
                      <div class="form-horizontal">
                        <div class="form-group">
                          <label class="col-sm-3 control-label">รหัสนักศึกษา</label>
                          <div class="col-sm-6">
                            <input ref="input" v-model="studentId" type="text" class="form-control">
                          </div>
                          <div class="col-sm-2">
                            <!-- <button class="btn btn-primary btn-block" type="button">ค้นหา</button> -->
                          </div>
                        </div>
                      </div>
                      <hr>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-default" data-dismiss="modal">ยกเลิก</button>
                      <button type="button" class="btn btn-primary" @click="addUserToGroup">เพิ่มผู้ประสานงาน</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="setAdvisorUserDialog" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                <span class="pficon pficon-close" />
              </button>
              <h4 class="modal-title">กำหนดอาจารย์ที่ปรึกษาหน่วยงาน</h4>
            </div>
            <div class="modal-body">
              <div class="alert alert-info">
                <span class="pficon pficon-info" />
                กรอกชื่อผู้ใช้งาน (Username) ของบัญชีที่ต้องการเพิ่มให้เป็นอาจารย์ที่ปรึกษาหน่วยงานนี้ (บัญชีนักศึกษาไม่สามารถเพิ่มได้)
              </div>
              <div class="form-horizontal">
                <div class="form-group">
                  <label class="col-sm-3 control-label">ชื่อผู้ใช้</label>
                  <div class="col-sm-6">
                    <input ref="input" v-model="setAdvisor.username" type="text" class="form-control">
                  </div>
                  <div class="col-sm-2">
                    <button class="btn btn-primary btn-block" type="button" @click.prevent="lookupUser">ค้นหา</button>
                  </div>
                </div>
                <div v-if="setAdvisor.lookupResult !== null" class="course-search-result">
                  <div v-if="setAdvisor.lookupResult" class="well">
                    <dl class="dl-horizontal no-margin">
                      <dt>ชื่อผู้ใช้</dt>
                      <dd>{{ setAdvisor.lookupResult.uid }}</dd>
                      <dt>ชื่อ</dt>
                      <dd>{{ setAdvisor.lookupResult.firstName }}</dd>
                      <dt>นามสกุล</dt>
                      <dd class="no-margin">{{ setAdvisor.lookupResult.lastName }}</dd>
                    </dl>
                  </div>
                  <div v-else class="alert alert-danger">
                    <span class="pficon pficon-error-circle-o" />
                    ไม่พบรายวิชา ตรวจสอบ Username อีกครั้ง
                  </div>
                </div>
              </div>
              <hr>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal" @click="clearForm">ยกเลิก</button>
              <button type="button" class="btn btn-primary" :disabled="setAdvisor.lookupResult === null || setAdvisor.lookupResult === false" @click="setAdvisorUser">กำหนดอาจารย์ที่ปรึกษา</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
export default {
  apollo: {
    group: {
      query: gql`query group($id: ID!){
        group(_id: $id) {
          name
          department
          type
          cheifName
          advisorName
          users {
            _id
            firstName
            lastName
          }
          advisor {
            firstName
            lastName
          }
        }
      }`,
      variables () {
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  data () {
    return {
      studentId: '',
      setAdvisor: {
        username: '',
        lookupResult: null
      }
    }
  },
  methods: {
    clearForm () {
      this.setAdvisor.lookupResult = null
      this.setAdvisor.username = ''
    },
    async lookupUser () {
      this.setAdvisor.lookupResult = null

      let user = await this.$apollo.query({
        query: gql`query userLookup($username: String!) {
          userLookup(role: "std", username: $username) {
            uid
            firstName
            lastName
          }
        }`,
        variables: {
          username: this.setAdvisor.username
        }
      })

      if (user.data.userLookup) {
        this.setAdvisor.lookupResult = user.data.userLookup
      } else {
        this.setAdvisor.lookupResult = false
      }
    },
    async setAdvisorUser () {
      await this.$apollo.mutate({
        mutation: gql`mutation ($username: String!, $groupId: ID!) {
          setAdvisorUser(username: $username, groupId: $groupId) {
            _id
          }
        }`,
        variables: {
          username: this.setAdvisor.username,
          groupId: this.$route.params.id
        }
      })

      this.$apollo.queries.group.refetch()

      // this.$router.go()
    },
    async addUserToGroup () {
      await this.$apollo.mutate({
        mutation: gql`mutation ($groupId: ID!, $userId: String!) {
          addUserToGroup(groupId: $groupId, username: $userId) {
            _id
          }
        }`,
        variables: {
          groupId: this.$route.params.id,
          userId: this.studentId
        }
      })

      location.reload()
    },
    async removeUserFromGroup (userId) {
      await this.$apollo.mutate({
        mutation: gql`mutation ($groupId: ID!, $userId: ID!) {
          removeUserFromGroup(groupId: $groupId, userId: $userId) {
            _id
          }
        }`,
        variables: {
          groupId: this.$route.params.id,
          userId: userId
        }
      })

      this.$router.go()
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/js/views/settings/groups/Show.vue